export class SharedConstants {
}
SharedConstants.APP_NAME = 'Formbird';
SharedConstants.SYSTEM_TYPE_DOCUMENT = 'document';
SharedConstants.SYSTEM_TYPE_VERSION = 'version';
SharedConstants.SYSTEM_TYPE_TEMPLATE = 'template';
SharedConstants.SYSTEM_TYPE_ACCOUNT = 'account';
SharedConstants.SYSTEM_TYPE_LOGIN = "login";
SharedConstants.SYSTEM_TYPE_RULESET_DOCUMENT = 'rulesetdocument';
SharedConstants.SYSTEM_TYPE_SYSTEM_ACTION = 'systemaction';
SharedConstants.SYSTEM_TYPE_SCHEDULE = 'schedule';
SharedConstants.SYSTEM_TYPE_FILE_REFERENCE = 'fileReference';
SharedConstants.SYSTEM_TYPE_CONFIGURATION = 'configuration';
SharedConstants.SYSTEM_TYPE_COMPONENT = 'component';
SharedConstants.SYSTEM_TYPE_COUNTER = 'counter';
SharedConstants.SYSTEM_TYPE_PASSWORD_RESET = 'passwordReset';
SharedConstants.SYSTEM_TYPE_ACCOUNT_SECURITY = 'accountSecurity';
SharedConstants.SYSTEM_TYPE_ACCOUNT_CONTROL = 'accountControl';
SharedConstants.SYSTEM_TYPE_ACCOUNT_GROUP_CONFIG = 'accountGroupConfig';
SharedConstants.SYSTEM_TYPE_PASSWORD = 'password';
SharedConstants.SYSTEM_TYPE_RULESET = 'ruleset';
SharedConstants.SYSTEM_TYPE_RULESET_INCLUDE = 'rulesetInclude';
SharedConstants.SYSTEM_TYPE_APPLICATION = 'application';
SharedConstants.SYSTEM_TYPE_VENDOR_LIBRARY = 'vendorLibrary';
SharedConstants.STATUS_PENDING = 'pending';
SharedConstants.STATUS_PROCESSING = 'processing';
SharedConstants.STATUS_PROCESSED = 'processed';
SharedConstants.STATUS_ERROR = 'error';
SharedConstants.STATUS_SUCCESS = 'success';
SharedConstants.STATUS_WARNING = 'warning';
SharedConstants.STATUS_INFO = 'info';
SharedConstants.STATUS_FORBIDDEN = 'forbidden';
SharedConstants.METHOD_POST = 'POST';
SharedConstants.METHOD_GET = 'GET';
SharedConstants.METHOD_DELETE = 'DELETE';
SharedConstants.METHOD_PUT = 'PUT';
SharedConstants.DEFAULT_PAGE = 0;
SharedConstants.DEFAULT_PAGE_SIZE = 50;
SharedConstants.DEFAULT_TOTAL_ITEM = 10000;
SharedConstants.DEFAULT_SEARCH_DELAY = 500;
SharedConstants.DEFAULT_MAX_SEARCH_QUERY_LENGTH = 2048;
SharedConstants.DEFAULT_SEARCH_SELECT_PAGE_SIZE = 5;
SharedConstants.DEFAULT_SEARCH_SELECT_PAGE = 0;
// field types
SharedConstants.FIELD_TYPE_RELATED = 'Related';
SharedConstants.FIELD_TYPE_HTML = 'html';
SharedConstants.FIELD_TYPE_CUSTOM = 'Custom';
SharedConstants.ELASTIC_DOCUMENT_TYPE = 'documents';
SharedConstants.ELASTIC_DOCUMENT_PREFIXES = {
    'mongodb': '_source'
};
SharedConstants.DEFAULT_DB_PROVIDER = 'mongodb';
SharedConstants.DEFAULT_DB_CONNECTION = 'default';
SharedConstants.RULESET_EVENT_NAME = 'EventName';
SharedConstants.RULESET_RELATIONSHIPS = {
    PRERENDER_EVENT_NAME: {
        name: 'PreRender',
        relName: 'preRenderClientRuleRel'
    },
    ONLOAD_EVENT_NAME: {
        name: 'OnLoad',
        relName: 'onLoadClientRuleRel'
    },
    ON_FIELD_CHANGE_EVENT_NAME: {
        name: 'OnFieldChange',
        relName: 'onFieldChangeClientRuleRel'
    },
    PRESAVE_EVENT_NAME: {
        name: 'PreSave',
        relName: 'preSaveClientRuleRel'
    },
    POSTSAVE_CLIENT_EVENT_NAME: {
        name: 'PostSaveClient',
        relName: 'postSaveClientRuleRel'
    },
    PRESAVE_SERVER_EVENT_NAME: {
        name: 'PreSaveServer',
        relName: 'preSaveServerRuleRel'
    },
    POSTSAVE_EVENT_NAME: {
        name: 'PostSave',
        relName: 'postSaveServerRuleRel'
    },
    POSTLOGIN_CLIENT_EVENT_NAME: {
        name: 'PostLoginClient',
        relName: 'postLoginClientRuleRel'
    },
    PRELOGOUT_CLIENT_EVENT_NAME: {
        name: 'PreLogoutClient',
        relName: 'preLogoutClientRuleRel'
    },
    PRELOGIN_SERVER_EVENT_NAME: {
        name: 'PreLoginServerName',
        relName: 'preLoginServerRuleRel'
    },
    POSTLOGIN_SERVER_EVENT_NAME: {
        name: 'PostLoginServerName',
        relName: 'postLoginServerRuleRel'
    },
    PRELOGOUT_SERVER_EVENT_NAME: {
        name: 'PreLogoutServerName',
        relName: 'preLogoutServerRuleRel'
    },
    POSTLOGOUT_SERVER_EVENT_NAME: {
        name: 'PostLogoutServerName',
        relName: 'postLogoutServerRuleRel'
    }
};
SharedConstants.ONLOAD_DONE_RULES_EVENT_NAME = 'OnLoadDone';
SharedConstants.ON_CHANGE_FILTER_EVENT_NAME = 'OnChangeFilter';
SharedConstants.LOCATION_CHANGE_STATE_EVENT = '$locationChangeStart';
SharedConstants.UPDATE_SHOW_VALUE_EVENT = 'updateShowValue';
SharedConstants.EVENT_LIST_NAME = 'eventList';
SharedConstants.EVENT_VALIDATION_VALUES_NAME = 'validationValues';
SharedConstants.EVENT_REFRESH_COMPONENT_NAME = 'refreshComponentData';
SharedConstants.INSERT_OPERATION_TYPE = 'Insert';
SharedConstants.UPDATE_OPERATION_TYPE = 'Update';
SharedConstants.CSV_DOC_ID_MATCH_MERGE = 'merge';
SharedConstants.CSV_DOC_ID_MATCH_REPLACE = 'replace';
SharedConstants.CSV_DOC_ID_NO_MATCH_ADD = 'add';
SharedConstants.CSV_DOC_ID_NO_MATCH_ERR = 'error';
// operation types for clicking on navigation bar
SharedConstants.SAVE_CLICK_OPERATION_TYPE = 'SaveClick';
SharedConstants.NEW_CLICK_OPERATION_TYPE = 'NewClick';
SharedConstants.PRINT_CLICK_OPERATION_TYPE = 'PrintClick';
SharedConstants.MAP_CLICK_OPERATION_TYPE = 'MapClick';
// operation types, for checking access
SharedConstants.OPERATION_TYPE_READ = 'Read';
SharedConstants.OPERATION_TYPE_CREATE = 'Create';
SharedConstants.OPERATION_TYPE_UPDATE = 'Update';
SharedConstants.OPERATION_TYPE_DELETE = 'Delete';
SharedConstants.OPERATION_TYPE_EXECUTE = 'Execute';
SharedConstants.OPERATION_TYPE_OFFLINE = 'Offline';
// error types, for server functions
SharedConstants.ERROR_TYPE_NOACCESS = 'No Access';
SharedConstants.ERROR_TYPE_NOTFOUND = 'Not Found';
SharedConstants.ERROR_TYPE_INTERNAL = 'Internal';
SharedConstants.ERROR_TYPE_GONE = 'Gone';
// websocket messages
SharedConstants.WEB_SOCKET_MESSAGE_TEMPLATE_DRAFT_SAVED = 'template_draft_saved';
SharedConstants.WEB_SOCKET_MESSAGE_UPDATE_PREVIEW = 'update_preview';
SharedConstants.WEB_SOCKET_MESSAGE_SAVE_DOCUMENT = 'save_document';
SharedConstants.WEB_SOCKET_MESSAGE_PASSWORD_RESET = 'password_reset';
SharedConstants.WEB_SOCKET_MESSAGE_SIGN_OUT_ALL_DEVICE = 'sign_out_all_device';
SharedConstants.DIALOG_OK_OPTION = 'OK';
SharedConstants.DIALOG_CANCEL_OPTION = 'CANCEL';
SharedConstants.RULESET_AFFECTED_DOCUMENT_ID = 'affectedDocId';
SharedConstants.RULESET_AFFECTED_TEMPLATE_ID = 'affectedTplId';
SharedConstants.RULESET_AFFECTED_FIELD_NAME = 'affectedFieldName';
SharedConstants.RULESET_NEW_FILTER = 'newFilter';
SharedConstants.RULESET_RESULT_FLAG = 'flag';
SharedConstants.RULESET_PARENT_DOCUMENT = 'parentDoc';
SharedConstants.RULESET_CHILD_DOCUMENT = 'childDoc';
SharedConstants.checkListSeparator = '^';
SharedConstants.DEFAULT_MESSAGE_LENGTH = 200;
SharedConstants.DEFAULT_EXPIRY_DURATION_MINUTES = 60;
SharedConstants.MAKE_CURRENT_VERSION_KEY = 'makeCurrentVersion';
SharedConstants.IMPORT_PREVIOUS_VERSION = "importPreviousVersion";
SharedConstants.SEARCH_PROVIDERS = {
    ELASTIC: 'elastic',
    MONGODB: 'mongodb'
};
SharedConstants.DOCUMENT_FIELD_NAME_UPLOAD_FILE = 'imageFileNo96'; // key used at systemHeader to refer to the uploaded file
SharedConstants.PASSWORD_RESET = "password:reset";
SharedConstants.DEFAULT_MAX_UPLOAD_SIZE = 50; //size in megabytes
SharedConstants.SYSTEM_TYPE_QUERY = "query";
